import * as Yup from 'yup'
import { Checkbox } from '@fullscreendigital/carrefour-dex-fe'
import DeleteActionIcon from '../../../../../../icons/DeleteActionIcon'
import { formatUIDateTime } from '../../../../../../utils/helpers'
import { Box } from '@mui/material'
import { DescriptionText } from 'components/core-ui/DescriptionText'

export const getValidationSchema = (editItem: ReturoReport) =>
  Yup.object().shape({
    cmrNumber: Yup.string()
      .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters and numbers are allowed')
      .required('Campul este obligatoriu.'),
    truckNumber: Yup.string()
      .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters and numbers are allowed')
      .required('Campul este obligatoriu.'),
    driverName: Yup.string()
      .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters and numbers are allowed')
      .required('Campul este obligatoriu.'),
    providerName: Yup.string()
      .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters and numbers are allowed')
      .required('Campul este obligatoriu.'),
    shopCode: Yup.string().required('Campul este obligatoriu.')
  })

export const getInitialValues = (
  editItem: ReturoReport,
  userShops: any,
  shopIds: any,
  returoSealModelList: any
) => {
  return {
    id: editItem?.id || null,
    idReturo: editItem?.idReturo || null,
    shopName: editItem?.shopName || null,
    shopCode: editItem?.shopCode || null,
    noticeNumber: editItem?.noticeNumber || null,
    cmrNumber: editItem?.cmrNumber || null,
    truckNumber: editItem?.truckNumber || null,
    driverName: editItem?.driverName || null,
    providerName: editItem?.providerName || null,
    userShops: userShops,
    shopIds: shopIds || [],
    returoSealModelList: returoSealModelList || []
  }
}

export const materialTypeColorMapping = {
  Cuvă: 'blue',
  Sac: 'green'
}

export const statusColorMapping = {
  Înregistrat: 'orange',
  'În predare': 'blue',
  Procesat: 'black',
  Predat: 'green',
  'Parțial trimis la meti': 'blue',
  'Trimis la Meti': 'green',
  Resigilat: 'orange',
  'Expediat din HUB': 'orange',
  'În procesare în HUB': 'blue',
  Succes: 'green',
  Lipsește: 'red',
  'În aşteptare': 'black',
  Expediat: 'orange'
}

export const buildColumns = ({
  toggleSealForNotice,
  deleteSeal,
  idNotice
}: {
  toggleSealForNotice: Function
  deleteSeal: Function
  idNotice: number
}) => [
  {
    title: 'Adauga la PV',
    field: 'checked',
    align: 'left',
    type: 'string',
    render: row => (
      <Checkbox
        checked={row.idNotice === idNotice || row.selectedForNotice}
        disabled={row.scanStatus === 'DELIVERED'}
        onChange={() => toggleSealForNotice(row, (event.target as HTMLInputElement).checked)}
      />
    )
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        {row.shopName}
      </Box>
    )
  },
  {
    title: 'ID Returo',
    field: 'idReturo',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        {row.idReturo}
      </Box>
    )
  },
  {
    title: 'Numar sigiliu',
    field: 'sealCode',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        <DescriptionText value={row.sealCode} maxWidth="100px"/>
      </Box>
    )
  },
  {
    title: 'Datǎ inregistrare',
    field: 'created',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        {formatUIDateTime(row.created)}
      </Box>
    )
  },
  {
    title: 'Operator',
    field: 'createdBy',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        {row.createdBy}
      </Box>
    )
  },
  {
    title: 'Status',
    field: 'status',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        <div style={{ color: statusColorMapping[row.scanStatusValue] || 'black' }}>
          {row.scanStatusValue}
        </div>
      </Box>
    )
  },
  {
    title: 'Material',
    field: 'materialType',
    align: 'left',
    type: 'string',
    render: row => (
      <Box style={{ lineHeight: '40px', fontFamily: 'Ubuntu', fontSize: '12px' }}>
        <div style={{ color: materialTypeColorMapping[row.materialTypeValue] || 'black' }}>
          {row.materialTypeValue}
        </div>
      </Box>
    )
  },
  {
    title: '',
    field: 'checked',
    align: 'left',
    type: 'string',
    render: row => (
      <Box
        onClick={() => (row.scanStatus === 'DELIVERED' ? null : deleteSeal(row.id))}
        style={{ position: 'relative', top: '10px', cursor: 'pointer' }}
      >
        <DeleteActionIcon />
      </Box>
    )
  }
]
